// source: organization_proto.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var satellite_routing_strategy_proto_pb = require('./satellite_routing_strategy_proto_pb.js');
goog.object.extend(proto, satellite_routing_strategy_proto_pb);
var subscription_proto_pb = require('./subscription_proto_pb.js');
goog.object.extend(proto, subscription_proto_pb);
goog.exportSymbol('proto.OrganizationExtrasRecord', null, global);
goog.exportSymbol('proto.OrganizationRecord', null, global);
goog.exportSymbol('proto.OrganizationRecord.OrganizationExtrasCase', null, global);
goog.exportSymbol('proto.OrganizationRecurlySettingsRecord', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.OrganizationRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.OrganizationRecord.oneofGroups_);
};
goog.inherits(proto.OrganizationRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.OrganizationRecord.displayName = 'proto.OrganizationRecord';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.OrganizationExtrasRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.OrganizationExtrasRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.OrganizationExtrasRecord.displayName = 'proto.OrganizationExtrasRecord';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.OrganizationRecurlySettingsRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.OrganizationRecurlySettingsRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.OrganizationRecurlySettingsRecord.displayName = 'proto.OrganizationRecurlySettingsRecord';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.OrganizationRecord.oneofGroups_ = [[5,6]];

/**
 * @enum {number}
 */
proto.OrganizationRecord.OrganizationExtrasCase = {
  ORGANIZATION_EXTRAS_NOT_SET: 0,
  EXTRAS: 5,
  EXTRAS_RECORD: 6
};

/**
 * @return {proto.OrganizationRecord.OrganizationExtrasCase}
 */
proto.OrganizationRecord.prototype.getOrganizationExtrasCase = function() {
  return /** @type {proto.OrganizationRecord.OrganizationExtrasCase} */(jspb.Message.computeOneofCase(this, proto.OrganizationRecord.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.OrganizationRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.OrganizationRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OrganizationRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.OrganizationRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
recurlyAccountCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
satelliteRoutingStrategy: jspb.Message.getFieldWithDefault(msg, 4, 0),
extras: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
extrasRecord: (f = msg.getExtrasRecord()) && proto.OrganizationExtrasRecord.toObject(includeInstance, f),
qbCustomerId: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OrganizationRecord}
 */
proto.OrganizationRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.OrganizationRecord;
  return proto.OrganizationRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OrganizationRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OrganizationRecord}
 */
proto.OrganizationRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecurlyAccountCode(value);
      break;
    case 4:
      var value = /** @type {!proto.SatelliteRoutingStrategy} */ (reader.readEnum());
      msg.setSatelliteRoutingStrategy(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtras(value);
      break;
    case 6:
      var value = new proto.OrganizationExtrasRecord;
      reader.readMessage(value,proto.OrganizationExtrasRecord.deserializeBinaryFromReader);
      msg.setExtrasRecord(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setQbCustomerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.OrganizationRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.OrganizationRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OrganizationRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.OrganizationRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRecurlyAccountCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSatelliteRoutingStrategy();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getExtrasRecord();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.OrganizationExtrasRecord.serializeBinaryToWriter
    );
  }
  f = message.getQbCustomerId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.OrganizationRecord.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.OrganizationRecord} returns this
 */
proto.OrganizationRecord.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.OrganizationRecord.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.OrganizationRecord} returns this
 */
proto.OrganizationRecord.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string recurly_account_code = 3;
 * @return {string}
 */
proto.OrganizationRecord.prototype.getRecurlyAccountCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.OrganizationRecord} returns this
 */
proto.OrganizationRecord.prototype.setRecurlyAccountCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional SatelliteRoutingStrategy satellite_routing_strategy = 4;
 * @return {!proto.SatelliteRoutingStrategy}
 */
proto.OrganizationRecord.prototype.getSatelliteRoutingStrategy = function() {
  return /** @type {!proto.SatelliteRoutingStrategy} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.SatelliteRoutingStrategy} value
 * @return {!proto.OrganizationRecord} returns this
 */
proto.OrganizationRecord.prototype.setSatelliteRoutingStrategy = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string extras = 5;
 * @return {string}
 */
proto.OrganizationRecord.prototype.getExtras = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.OrganizationRecord} returns this
 */
proto.OrganizationRecord.prototype.setExtras = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.OrganizationRecord.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.OrganizationRecord} returns this
 */
proto.OrganizationRecord.prototype.clearExtras = function() {
  return jspb.Message.setOneofField(this, 5, proto.OrganizationRecord.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.OrganizationRecord.prototype.hasExtras = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional OrganizationExtrasRecord extras_record = 6;
 * @return {?proto.OrganizationExtrasRecord}
 */
proto.OrganizationRecord.prototype.getExtrasRecord = function() {
  return /** @type{?proto.OrganizationExtrasRecord} */ (
    jspb.Message.getWrapperField(this, proto.OrganizationExtrasRecord, 6));
};


/**
 * @param {?proto.OrganizationExtrasRecord|undefined} value
 * @return {!proto.OrganizationRecord} returns this
*/
proto.OrganizationRecord.prototype.setExtrasRecord = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.OrganizationRecord.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.OrganizationRecord} returns this
 */
proto.OrganizationRecord.prototype.clearExtrasRecord = function() {
  return this.setExtrasRecord(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.OrganizationRecord.prototype.hasExtrasRecord = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string qb_customer_id = 7;
 * @return {string}
 */
proto.OrganizationRecord.prototype.getQbCustomerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.OrganizationRecord} returns this
 */
proto.OrganizationRecord.prototype.setQbCustomerId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.OrganizationExtrasRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.OrganizationExtrasRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OrganizationExtrasRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.OrganizationExtrasRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
recurlySettings: (f = msg.getRecurlySettings()) && proto.OrganizationRecurlySettingsRecord.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OrganizationExtrasRecord}
 */
proto.OrganizationExtrasRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.OrganizationExtrasRecord;
  return proto.OrganizationExtrasRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OrganizationExtrasRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OrganizationExtrasRecord}
 */
proto.OrganizationExtrasRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.OrganizationRecurlySettingsRecord;
      reader.readMessage(value,proto.OrganizationRecurlySettingsRecord.deserializeBinaryFromReader);
      msg.setRecurlySettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.OrganizationExtrasRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.OrganizationExtrasRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OrganizationExtrasRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.OrganizationExtrasRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecurlySettings();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.OrganizationRecurlySettingsRecord.serializeBinaryToWriter
    );
  }
};


/**
 * optional OrganizationRecurlySettingsRecord recurly_settings = 1;
 * @return {?proto.OrganizationRecurlySettingsRecord}
 */
proto.OrganizationExtrasRecord.prototype.getRecurlySettings = function() {
  return /** @type{?proto.OrganizationRecurlySettingsRecord} */ (
    jspb.Message.getWrapperField(this, proto.OrganizationRecurlySettingsRecord, 1));
};


/**
 * @param {?proto.OrganizationRecurlySettingsRecord|undefined} value
 * @return {!proto.OrganizationExtrasRecord} returns this
*/
proto.OrganizationExtrasRecord.prototype.setRecurlySettings = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.OrganizationExtrasRecord} returns this
 */
proto.OrganizationExtrasRecord.prototype.clearRecurlySettings = function() {
  return this.setRecurlySettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.OrganizationExtrasRecord.prototype.hasRecurlySettings = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.OrganizationRecurlySettingsRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.OrganizationRecurlySettingsRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OrganizationRecurlySettingsRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.OrganizationRecurlySettingsRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
manualPaymentCollection: (f = jspb.Message.getBooleanField(msg, 1)) == null ? undefined : f,
defaultSubscriptionPlan: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OrganizationRecurlySettingsRecord}
 */
proto.OrganizationRecurlySettingsRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.OrganizationRecurlySettingsRecord;
  return proto.OrganizationRecurlySettingsRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OrganizationRecurlySettingsRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OrganizationRecurlySettingsRecord}
 */
proto.OrganizationRecurlySettingsRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setManualPaymentCollection(value);
      break;
    case 3:
      var value = /** @type {!proto.SubscriptionRequest.Plan} */ (reader.readEnum());
      msg.setDefaultSubscriptionPlan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.OrganizationRecurlySettingsRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.OrganizationRecurlySettingsRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OrganizationRecurlySettingsRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.OrganizationRecurlySettingsRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {boolean} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBool(
      1,
      f
    );
  }
  f = /** @type {!proto.SubscriptionRequest.Plan} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional bool manual_payment_collection = 1;
 * @return {boolean}
 */
proto.OrganizationRecurlySettingsRecord.prototype.getManualPaymentCollection = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.OrganizationRecurlySettingsRecord} returns this
 */
proto.OrganizationRecurlySettingsRecord.prototype.setManualPaymentCollection = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.OrganizationRecurlySettingsRecord} returns this
 */
proto.OrganizationRecurlySettingsRecord.prototype.clearManualPaymentCollection = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.OrganizationRecurlySettingsRecord.prototype.hasManualPaymentCollection = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SubscriptionRequest.Plan default_subscription_plan = 3;
 * @return {!proto.SubscriptionRequest.Plan}
 */
proto.OrganizationRecurlySettingsRecord.prototype.getDefaultSubscriptionPlan = function() {
  return /** @type {!proto.SubscriptionRequest.Plan} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.SubscriptionRequest.Plan} value
 * @return {!proto.OrganizationRecurlySettingsRecord} returns this
 */
proto.OrganizationRecurlySettingsRecord.prototype.setDefaultSubscriptionPlan = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.OrganizationRecurlySettingsRecord} returns this
 */
proto.OrganizationRecurlySettingsRecord.prototype.clearDefaultSubscriptionPlan = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.OrganizationRecurlySettingsRecord.prototype.hasDefaultSubscriptionPlan = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto);
